import { SET_MY_DEFAULT_STORE } from '../actionTypes/SetMyDefaultStoreActionTypes';

const setMyDefaultStore = () => ({
    type: SET_MY_DEFAULT_STORE,
});

export default {
    setMyDefaultStore,
};
